var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.381 14.4h-.439v-3.227c0-1.75-1.446-3.173-3.223-3.173h-2.438c-1.777 0-3.223 1.423-3.223 3.173V14.4h-.439C8.73 14.4 8 15.119 8 15.998v6.405C8 23.28 8.728 24 9.62 24h9.76c.89 0 1.62-.719 1.62-1.597v-6.405c0-.88-.728-1.598-1.619-1.598zm-4.204 4.62v2.514a.337.337 0 0 1-.339.333h-.677a.337.337 0 0 1-.338-.333V19.02a1.329 1.329 0 0 1-.677-1.154c0-.736.606-1.334 1.354-1.334.749 0 1.354.598 1.354 1.334 0 .493-.273.923-.677 1.154zm1.598-4.62h-4.55v-3.227c0-.573.473-1.04 1.055-1.04h2.438a1.05 1.05 0 0 1 1.057 1.04V14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 34c-.02 0-.041 0-.062-.002-.227-.013-5.613-.388-9.89-5.477C.862 23.537-.733 15.942.31 5.947c.042-.404.31-.748.688-.887L14.64.064c.232-.085.486-.085.718 0L29.002 5.06c.379.139.646.483.688.887 1.044 9.995-.55 17.59-4.739 22.574-4.276 5.089-9.662 5.464-9.89 5.477A.967.967 0 0 1 15 34zM2.338 6.83c-.847 9.066.604 15.9 4.316 20.316 3.463 4.12 7.767 4.67 8.343 4.725.573-.058 4.935-.634 8.381-4.764 3.688-4.419 5.128-11.24 4.284-20.278L15 2.193 2.338 6.83z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuth);
export default __webpack_public_path__ + "static/media/auth.d16f4befe34b8f2b42224369d2141489.svg";
export { ForwardRef as ReactComponent };